module.exports = __webpack_public_path__ + "static/img/28.982d4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/28.jpg
// module id = 5QF8
// module chunks = 0